import actionTypes from '../constants/action-types';

export default (pageId, html) => ({
  type: actionTypes.SET_PAGE_HTML,
  payload: {
    pageId,
    html,
  },
});
